import React from 'react'
import PropTypes from 'prop-types'
import Attachment from '#components/m/Ausbildungsnachweis/Attachment'
import {useSharedFileUrl} from '#hooks/useSharedFileUrl'
import {getWindow} from '#helpers/window'

export default function PdfAttachment(props) {
  const {isReadOnly, file, handleAttachmentDelete, userId} = props
  const userFile = useSharedFileUrl(file.blobId, userId)
  if (userFile.isLoading || userFile.notFound) {
    return null
  }

  return (
    <div
      tabIndex="0"
      role="button"
      className="pdf__attachment"
      onClick={() => {
        getWindow().open(userFile.url, '_blank')
      }}
      onKeyPress={() => {
        getWindow().open(userFile.url, '_blank')
      }}
    >
      <Attachment
        isReadOnly={isReadOnly}
        filename={file.originalFilename}
        onDelete={handleAttachmentDelete(file.blobId)}
      />
    </div>
  )
}

PdfAttachment.propTypes = {
  handleAttachmentDelete: PropTypes.func,
  file: PropTypes.shape({
    originalFilename: PropTypes.string,
    blobId: PropTypes.string,
    fileType: PropTypes.string,
  }),
  isReadOnly: PropTypes.bool,
  userId: PropTypes.number,
}
